export enum DonationSource {
    BackStore = 0,
    FrontStore = 1
}